import { useEffect, useRef } from 'react'
import { useToast } from '@chakra-ui/react'
import { usePaywallContext } from '../contexts/PaywallContext'
import { useAuthContext } from '../contexts/AuthContext'

export function PaymentAlertToast() {
  const toast = useToast()
  const { hasPaymentIssues, isLoading, trialDaysRemaining } = usePaywallContext()
  const { isAuthenticated } = useAuthContext()
  const hasShownToast = useRef(false)

  useEffect(() => {
    // Don't show payment failed toast for users in active trial
    const isInActiveTrial = trialDaysRemaining !== null && trialDaysRemaining > 0

    // Only show toast once per session, when authenticated, not loading, 
    // has payment issues, and NOT in an active trial
    if (
      isAuthenticated &&
      !isLoading &&
      hasPaymentIssues &&
      !isInActiveTrial &&
      !hasShownToast.current
    ) {
      hasShownToast.current = true
      
      toast({
        title: 'Payment Failed',
        description: 'Your card payment failed. Please update your payment method to continue your subscription.',
        status: 'error',
        duration: null, // Don't auto-dismiss
        isClosable: true,
        position: 'top',
      })
    }
  }, [isAuthenticated, isLoading, hasPaymentIssues, trialDaysRemaining, toast])

  // Reset the flag when user logs out
  useEffect(() => {
    if (!isAuthenticated) {
      hasShownToast.current = false
    }
  }, [isAuthenticated])

  return null // This component doesn't render anything
}
